module.exports = __webpack_public_path__ + "static/media/creditcard-default.5068aabe.png";